"use client";

import React from "react";
import { Phone, Loader, CircleCheck, CircleAlert } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
function SupportForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 text-center space-y-4 animate-in fade-in zoom-in duration-500">
                <div className="size-16 rounded-lg bg-primary/20 flex items-center justify-center mb-4">
                    <CircleCheck className="size-8 text-primary" />
                </div>
                <h3 className="font-default text-2xl font-bold text-foreground">Richiesta Inviata</h3>
                <p className="text-muted-foreground font-default max-w-sm">
                    {successMessage}
                </p>
                <Button onClick={resetForm} variant="outline" className="mt-6 border-secondary text-secondary hover:bg-secondary/10">
                    Invia un'altra richiesta
                </Button>
            </div>;
  }
  const inputClasses = "flex h-11 w-full rounded-md border-b border-t-0 border-x-0 border-input bg-transparent px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50 transition-colors";
  return <Form onSubmit={handleSubmit} className="space-y-5">
            <FormField control={control} name="name" rules={{
      required: "Il nome è obbligatorio"
    }} render={({
      field
    }) => <FormItem>
                        <FormLabel className="font-default uppercase tracking-wider text-xs font-medium">Nome Completo</FormLabel>
                        <FormControl>
                            <input type="text" placeholder="Mario Rossi" className={inputClasses} {...field} />
                        </FormControl>
                        <FormDescription className="text-[10px] uppercase tracking-widest opacity-70">Inserisci il tuo nome e cognome.</FormDescription>
                        <FormMessage />
                    </FormItem>} />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <FormField control={control} name="email" rules={{
        required: "Email obbligatoria",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Formato email non valido"
        }
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="font-default uppercase tracking-wider text-xs font-medium">Email</FormLabel>
                            <FormControl>
                                <input type="email" placeholder="mario@esempio.it" className={inputClasses} {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />

                <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
                            <FormLabel className="font-default uppercase tracking-wider text-xs font-medium">Telefono</FormLabel>
                            <FormControl>
                                <input type="tel" placeholder="+39 012 345 6789" className={inputClasses} {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />
            </div>

            <FormField control={control} name="issue_type" rules={{
      required: "Seleziona una categoria"
    }} render={({
      field
    }) => <FormItem>
                        <FormLabel className="font-default uppercase tracking-wider text-xs font-medium">Tipo di Richiesta</FormLabel>
                        <FormControl>
                            <select className={inputClasses} {...field}>
                                <option value="" disabled>Seleziona categoria</option>
                                <option value="Technical Issue">Consulenza Tecnica</option>
                                <option value="Billing">Preventivo Personalizzato</option>
                                <option value="General Inquiry">Informazioni Generali</option>
                                <option value="Other">Altro</option>
                            </select>
                        </FormControl>
                        <FormMessage />
                    </FormItem>} />

            <FormField control={control} name="message" rules={{
      required: "Descrivi la tua richiesta"
    }} render={({
      field
    }) => <FormItem>
                        <FormLabel className="font-default uppercase tracking-wider text-xs font-medium">Messaggio</FormLabel>
                        <FormControl>
                            <textarea placeholder="Descrivi i dettagli della tua uscita o le tue necessità..." className={`${inputClasses} min-h-[120px] resize-y`} {...field} />
                        </FormControl>
                        <FormDescription className="text-[10px] uppercase tracking-widest opacity-70">Fornisci dettagli per ricevere una risposta accurata entro 24 ore.</FormDescription>
                        <FormMessage />
                    </FormItem>} />

            {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md flex items-start gap-3 text-destructive">
                    <CircleAlert className="size-5 shrink-0 mt-0.5" />
                    <p className="text-sm font-medium">{submitError}</p>
                </div>}

            <Button type="submit" disabled={isSubmitting} size="lg" className="w-full font-default text-lg tracking-widest uppercase bg-primary hover:bg-primary/90 text-white border-b-2 border-secondary">
                {isSubmitting ? <>
                        <Loader className="animate-spin mr-2 size-5" />
                        Invio in corso...
                    </> : 'Invia Richiesta'}
            </Button>
        </Form>;
}
export default function RoundTheClockSupport() {
  return <section data-section-id="226393" id="pianifica-la-tua-uscita" className="dark bg-background text-foreground py-24 relative overflow-hidden">
            {}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
                <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary/10 rounded-md blur-3xl"></div>
                <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-secondary/10 rounded-md blur-3xl"></div>
            </div>

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                    
                    {}
                    <div className="space-y-8">
                        <div className="space-y-4">
                            <Badge variant="outline" className="text-secondary border-secondary/30 font-default tracking-widest uppercase text-xs">
                                Consulenza Elite
                            </Badge>
                            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-foreground">
                                Pronto per <span className="text-primary-foreground">salpare?</span> La tua rotta inizia qui.
                            </h2>
                            <p className="font-default text-lg text-muted-foreground max-w-xl leading-relaxed">
                                Il nostro team di broker esperti è a tua disposizione per pianificare ogni dettaglio. Garantiamo una risposta professionale e un preventivo personalizzato entro 24 ore.
                            </p>
                        </div>

                        <div className="pt-8 border-t border-secondary/20">
                            <div className="flex items-center gap-6">
                                {}
                                <div className="relative flex items-center justify-center size-20 shrink-0">
                                    <div className="absolute inset-0 rounded-md bg-primary/10 animate-[pulse_3s_ease-in-out_infinite]"></div>
                                    <div className="relative z-10 flex items-center justify-center size-14 rounded-md bg-primary text-white shadow-lg shadow-primary/20">
                                        <Phone className="size-6" />
                                    </div>
                                </div>
                                
                                <div>
                                    <p className="text-muted-foreground text-sm font-default mb-1 font-medium uppercase tracking-widest">
                                        Linea Diretta Broker
                                    </p>
                                    <Link to="tel:+39 3202766022" className="font-default text-3xl sm:text-4xl md:text-5xl font-bold text-foreground hover:text-primary transition-colors block">+39 3202766022</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    {}
                    <div className="relative">
                        {}
                        <Badge className="absolute -top-4 -right-4 md:-right-6 bg-secondary hover:bg-secondary/90 text-white border-none shadow-xl z-20 px-4 py-2 text-base font-bold font-default rounded-md rotate-0 transform transition-transform hover:scale-105">
                            RISPOSTA 24H
                        </Badge>

                        <Card className="relative z-10 bg-card/95 backdrop-blur-md border-secondary/20 shadow-2xl shadow-black/40 overflow-hidden">
                            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary via-secondary to-primary"></div>
                            <CardHeader className="pb-6 border-b border-border/50 bg-muted/10">
                                <CardTitle className="font-default text-2xl md:text-3xl font-bold uppercase tracking-tight">
                                    Pianifica la Tua Uscita
                                </CardTitle>
                                <CardDescription className="font-default text-base">
                                    Compila il form per ricevere una consulenza tecnica e un preventivo su misura.
                                </CardDescription>
                            </CardHeader>
                            <CardContent className="pt-8">
                                <FormProvider formKey="outing_form_home" formId="outing_form_home" sectionName="RoundTheClockSupport" defaultValues={{
                name: "",
                email: "",
                phone: "",
                issue_type: "",
                message: ""
              }} validationRules={{
                name: {
                  required: true
                },
                email: {
                  required: true,
                  pattern: "email"
                },
                issue_type: {
                  required: true
                },
                message: {
                  required: true
                }
              }} submitText="Invia Richiesta" successMessage="Grazie. La tua richiesta è stata presa in carico. Un nostro broker ti contatterà entro 24 ore." errorMessage="Si è verificato un errore. Per favore controlla i dati e riprova.">
                                    <SupportForm />
                                </FormProvider>
                            </CardContent>
                        </Card>
                    </div>

                </div>
            </div>
        </section>;
}